<template>
  <div>
    <div class="wrap coaching-request-wrap">
      <div class="top-header">
        <h3>my 코칭</h3>
      </div>
      <div class="body-wrap">
        <incMenu></incMenu>
        <div class="coaching-list">
          <div class="coaching">
            <p>예약 요청 건</p>
            <ul>
              <li class="clear default" @click="coachingRequest(item.sessionIdx)" v-for="(item, index) in request" :key="index">
                <div class="w-40per float-left">
                  <span>{{ item.sessionType }}</span>
                  <h1>{{ item.userName }}</h1>
                </div>
                <div class="w-60per float-left">
                  <p>
                    {{ item.startDate }} {{ item.startTime }}~{{ item.endTime }}&nbsp;&nbsp;|&nbsp;&nbsp;{{ item.sessionPer }}
                  </p>
                </div>
              </li>
              <!-- <li class="clear default" @click="coachingRequest()">
                                <div class="w-40per float-left">
                                    <span>전화</span>
                                    <h1>김소연</h1>
                                </div>
                                <div class="w-60per float-left">
                                    <p>2021.08.11 09:00~10:00&nbsp;&nbsp;|&nbsp;&nbsp;2/10</p>
                                </div>
                            </li> -->
            </ul>
          </div>
        </div>
        <incTab></incTab>
      </div>
    </div>
  </div>
</template>
<script>
import incMenu from "@/components/inc/inc_menu.vue";
import incTab from "@/components/inc/inc_tab.vue";
import dayjs from "dayjs";
export default {
  name: "coaching_request",
  data: () => ({
    request: [],
  }),
  components: {
    incMenu,
    incTab,
  },
  mounted() {
    this.getCoarchingRequest();
  },
  methods: {
    getCoarchingRequest() {
      let params = {
        coarIdx: localStorage.getItem("idxTbCoarch"),
      };
      this.axios
        .get("/front/coarching/reservation/list", { params })
        .then((res) => {
          if (res.data.success) {
            this.request = res.data.data;
            for (let item of this.request) {
              item.startTime = dayjs(item.startDate).format("HH:mm");
              item.endTime = dayjs(item.endDate).format("HH:mm");
              item.startDate = dayjs(item.startDate).format("YYYY.MM.DD");
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    coachingRequest(sessionIdx) {
      this.$router.push({ name: "reservation_coaching_request", params: { sessionIdx: sessionIdx } });
    },
  },
};
</script>
